module.exports = __webpack_public_path__ + "static/media/check-double.66403829.svg";